
import { Injectable } from '@angular/core';
import { GeoFence } from '../../shared/models/admin/geo-fence';
import { HttpClientService } from '../../core/http-client/http-client.service';
import { BusinessType } from '@app/shared/models/admin/business-type';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessTypeService {

  private static readonly endpoint = 'BusinessType';
  constructor(private http: HttpClientService) { }

  get(id: number) {
    return this.http.get<BusinessType>(`${BusinessTypeService.endpoint}/Details/${id}`);
  }

  create(model: Object): Observable<BusinessType> {
    return this.http.post(model, `${BusinessTypeService.endpoint}/Create`, undefined);
  }

  update(model: object): Observable<any> {
    return this.http.put(model, `${BusinessTypeService.endpoint}/Update`);
  }
 
  list() {
    return this.http.get<BusinessType[]>(`${BusinessTypeService.endpoint}/GetAll`);
  }
}
